import React, { useState } from 'react';
import './PasscodeScreen.css';

const PasscodeScreen = ({ onSubmit }) => {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = () => {
    const result = onSubmit(passcode);
    if (result === false) {
      setError(true);
      setPasscode('');
      setTimeout(() => setError(false), 3000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="passcode-screen">
      <div className="passcode-container">
        <div className="heart-decoration">💕</div>
        <h1 className="passcode-title">Christian & Mira — Where Our Hearts Met</h1>
        <p className="passcode-subtitle">Enter the passcode to continue</p>

        <div className="passcode-input-group">
          <input
            type="password"
            className="passcode-input"
            placeholder="••••••"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            onKeyPress={handleKeyPress}
            autoFocus
          />
          <button className="passcode-btn" onClick={handleSubmit}>
            Enter
          </button>
          {error && <div className="passcode-error show">Incorrect passcode. Try again.</div>}
        </div>
      </div>
    </div>
  );
};

export default PasscodeScreen;
